import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthenticationContainer } from 'entities/Authentication';
import { LANGUAGES } from 'entities/Language';
import { useUserAuthData } from 'entities/User';
import { CreateInvite } from 'features/CreateInvite';
import { getRouteMain, getRouteRussiaLanding } from 'shared/consts/routes';
import { setIngressPath } from 'shared/lib/ingressPath';
import { Typography } from 'shared/_ui';

import styles from './styles.module.scss';

export const RussiaLandingPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const authData = useUserAuthData();
  const navigate = useNavigate();

  React.useEffect(() => {
    i18n.changeLanguage(LANGUAGES[1]);
    setIngressPath(getRouteRussiaLanding());
  }, [i18n]);

  React.useEffect(() => {
    if (authData) navigate(getRouteMain());
  }, [authData, navigate]);

  const benefits = t('landing.russia.benefits', {
    returnObjects: true,
  }) as string[];

  return (
    <AuthenticationContainer
      title={
        <div className={styles.title}>
          <Typography.Title level={2}>
            {t('landing.russia.title')}
          </Typography.Title>
          <Typography.Text className={styles.titleSubtitle}>
            {t('landing.russia.titleSubtitle')}
          </Typography.Text>
        </div>
      }
    >
      <div className={styles.content}>
        <div className={styles.hero}>
          <Typography.Text type="success" strong className={styles.badge}>
            <span aria-hidden="true">🎁</span> {t('landing.russia.badge')}
          </Typography.Text>
          <Typography.Text type="secondary" className={styles.subtitle}>
            {t('landing.russia.subtitle')}
          </Typography.Text>
          <ul className={styles.benefits}>
            {benefits.map((benefit) => (
              <li key={benefit}>
                <span className={styles.check} aria-hidden="true">
                  ✓
                </span>
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
        </div>
        <CreateInvite ruOnboarding />
      </div>
    </AuthenticationContainer>
  );
};
